/* eslint-disable import/prefer-default-export */
const THOUSAND_SEPARATOR = '.';
const DECIMAL_SEPARATOR = ',';

const _regExp = new RegExp(/(\d)(?=(\d{3})+(?!\d))/, 'g');
const isStringOrNumber = (n) => typeof n === 'string' || typeof n === 'number';
const isValidNumber = (n) => !Number.isNaN(parseInt(n, 10));
const isFloat = (n) =>
  n.toString().includes(THOUSAND_SEPARATOR) || n.toString().includes(DECIMAL_SEPARATOR);

const _formatInt = (amount) =>
  parseFloat(amount.toString().replace(THOUSAND_SEPARATOR, DECIMAL_SEPARATOR))
    .toFixed()
    .replace(THOUSAND_SEPARATOR, DECIMAL_SEPARATOR)
    .replace(_regExp, '$1.');

const _formatFloat = (amount) =>
  amount.toString().replace(THOUSAND_SEPARATOR, DECIMAL_SEPARATOR).replace(_regExp, '$1.');
/* istanbul ignore next */
const _processValue = (amount) => {
  let result = 0;

  if (isStringOrNumber(amount) && isValidNumber(amount))
    result = isFloat(amount) ? _formatFloat(amount) : _formatInt(amount);

  return result;
}; 

export const toCurrencyFormat = (amount, noSymbol = false) =>
  `${noSymbol ? '' : '$ '}${_processValue(amount)}`;
